<template>
    <q-card flat>
        <q-card-section class="no-padding">
            <q-select v-model="selectedStorID"
                      :options="storList"
                      option-label="StorName"
                      option-value="StorID"
                      filled
                      label="عنوان انبار را انتخاب کنید"
            />
        </q-card-section>
        <q-card-actions>
            <q-btn label="نمایش گزارش" color="indigo" text-color="white" icon="visibility" @click="loadReport"/>
        </q-card-actions>
    </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: "WarehouseHandling",
    components: {},
    data() {
        return {
            storList: [],
            selectedStorID: undefined
        }
    },
    methods: {
        ...mapActions({
            getStorList: 'Products/getStoreList'
        }),
        async loadReport() {
            if (this.selectedStorID === undefined) return;
            await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات انبار/فرم انبارگردانی/?rs:Format=PDF&StoreID=${this.selectedStorID.StorID}&rc:Parameters=False&rc:Zoom=Page Width`)
        }
    },
    created() {
        this.getStorList().then((res) => {
            this.storList = res
        })
    }
}
</script>

<style scoped>

</style>